import { render, staticRenderFns } from "./ActionCountWidgets.vue?vue&type=template&id=066f7537&scoped=true&"
import script from "./ActionCountWidgets.vue?vue&type=script&lang=js&"
export * from "./ActionCountWidgets.vue?vue&type=script&lang=js&"
import style0 from "./ActionCountWidgets.vue?vue&type=style&index=0&id=066f7537&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066f7537",
  null
  
)

export default component.exports